var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_preview_close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.52717 21C4.11246 21 3.75426 20.8491 3.45257 20.5474C3.15086 20.2457 3 19.8875 3 19.4728V4.52717C3 4.11247 3.15086 3.75427 3.45257 3.45257C3.75426 3.15086 4.11246 3 4.52717 3H19.4728C19.8875 3 20.2457 3.15086 20.5474 3.45257C20.8491 3.75427 21 4.11247 21 4.52717V19.4728C21 19.8875 20.8491 20.2457 20.5474 20.5474C20.2457 20.8491 19.8875 21 19.4728 21H4.52717ZM4.52717 19.7987H19.4728C19.5679 19.7987 19.6459 19.7681 19.707 19.707C19.7681 19.6459 19.7987 19.5679 19.7987 19.4728V6.319H4.20134V19.4728C4.20134 19.5679 4.23189 19.6459 4.29299 19.707C4.35408 19.7681 4.43214 19.7987 4.52717 19.7987Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.9495 15.9123C12.6459 15.9699 12.3326 16 12.0123 16C9.77349 16 7.87834 14.5285 7.24121 12.5C7.41466 11.9477 7.68134 11.4368 8.0228 10.9856M10.9514 11.4393C11.2229 11.1679 11.5979 11 12.0121 11C12.8405 11 13.5121 11.6716 13.5121 12.5C13.5121 12.9142 13.3442 13.2892 13.0727 13.5607M10.9514 11.4393L13.0727 13.5607M10.9514 11.4393L9.30666 9.79458M13.0727 13.5607L14.7177 15.2056M7.51208 8L9.30666 9.79458M9.30666 9.79458C10.0866 9.29177 11.0154 9 12.0123 9C14.2511 9 16.1463 10.4715 16.7834 12.5C16.43 13.6254 15.6893 14.5793 14.7177 15.2056M14.7177 15.2056L16.5121 17",
    stroke: "#343333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotView);
export default __webpack_public_path__ + "static/media/not-view.3cbc21337d4093e002da7cadb8ebb31b.svg";
export { ForwardRef as ReactComponent };